var CSSCONSTANTS = CSSCONSTANTS || {};

(function () {

    /* mobile max width */
    CSSCONSTANTS.mobileMaxWidth = '600px';
    CSSCONSTANTS.mobileMaxWidthMQ = 'screen and (max-width: ' + CSSCONSTANTS.mobileMaxWidth + ')';

    /* non mobile min width */
    CSSCONSTANTS.nonMobileMinWidth = '601px';
    CSSCONSTANTS.nonMobileMinWidthMQ = 'screen and (min-width: ' + CSSCONSTANTS.nonMobileMinWidth + ')';

    /* mobile global header max width */
    CSSCONSTANTS.mobileHeaderMaxWidth = '800px';
    CSSCONSTANTS.mobileHeaderMaxWidthMQ = 'screen and (max-width: ' + CSSCONSTANTS.mobileHeaderMaxWidth + ')';

    /* non mobile global header min width */
    CSSCONSTANTS.nonMobileHeaderMinWidth = '801px';
    CSSCONSTANTS.nonMobileHeaderMinWidthMQ = 'screen and (min-width: ' + CSSCONSTANTS.nonMobileHeaderMinWidth + ')';

    /* non desktop (inc. tablet) max width */
    CSSCONSTANTS.nonDesktopMaxWidth = '900px';
    CSSCONSTANTS.nonDesktopMaxWidthMQ = 'screen and (max-width: ' + CSSCONSTANTS.nonDesktopMaxWidth + ')';

    /* desktop min width */
    CSSCONSTANTS.desktopMinWidth = '901px';
    CSSCONSTANTS.desktopMinWidthMQ = 'screen and (min-width: ' + CSSCONSTANTS.desktopMinWidth + ')';

    /* hidden */
    CSSCONSTANTS.hiddenClass = 'hidden';
    CSSCONSTANTS.hiddenMobileOnlyClass = 'hidden-mobile-only';
    CSSCONSTANTS.hiddenTabletAndMobileClass = 'hidden-tablet-and-mobile';

    /* colours */
    CSSCONSTANTS.backgroundBlueClass = 'bg-blue';
    CSSCONSTANTS.backgroundPastel2Class = 'bg-pastel2';

    /* grid */
    CSSCONSTANTS.bandClass = 'band';
    CSSCONSTANTS.noBottomPaddingClass = 'no-bottom-padding';
    CSSCONSTANTS.rowClass = 'row';
    CSSCONSTANTS.columnClass = 'col';
    CSSCONSTANTS.scaffoldClass = 'scaffold';
    CSSCONSTANTS.gridUnit = 20;
    CSSCONSTANTS.buttonClass = 'btn';
    CSSCONSTANTS.boxClass = 'box';
    CSSCONSTANTS.reverseClass = 'reverse';

    /* buttons */
    CSSCONSTANTS.btnClass = 'btn';
    CSSCONSTANTS.btnBlueClass = 'btn--blue';
    CSSCONSTANTS.btnGreenClass = 'btn--green';

    /* forms - used by _partials/Forms/errorIndication.js */
    CSSCONSTANTS.formRowClass = 'form-row';
    CSSCONSTANTS.errorMessageClass = 'error-message';
    CSSCONSTANTS.labelErrorClass = 'label-error';
    CSSCONSTANTS.fieldErrorClass = 'field-error';

    /* replaced inputs - used by Carfused and Products */
    CSSCONSTANTS.replacedInputClass = 'replaced-input';
    CSSCONSTANTS.replacedInputLabelClass = 'replaced-input-label';
    CSSCONSTANTS.replacedInputLabelFocussedClass = 'replaced-input-label--focussed';
    CSSCONSTANTS.replacedInputLabelSelectedClass = 'replaced-input-label--selected';


})();